import { Helmet } from "react-helmet-async";

const FAQ = () => {
  return (
        <>
        <Helmet>
            <title>FAQs</title>
          </Helmet>
    <div className="bg-black w-full min-h-screen text-white px-8 md:px-[8vw] py-12 md:py-[4vw]">
      <h1 className="text-4xl text-center md:text-left md:text-[4vw] font-bold mb-8 md:mb-12">
        FAQ
      </h1>

      <div className="mb-10 flex flex-col">
        <h2 className="text-xl md:text-[1.6vw] md:leading-[2vw] font-bold mb-2">
          How do I send cases for designs?
        </h2>
        <p className="text-gray-200 text-md md:text-[1.25vw] md:leading-[2vw]">
          Click on{" "}
          <a href="/dashboard" className="text-blue-600 underline">
            Upload Case
          </a>
          , register and create your new account. Once you have logged into your
          account, your dashboard will have an ‘Start case submission’ option.
          Just click on that, upload your scans with relevant instructions, and
          that’s it.
        </p>
        <p className="mt-4 text-gray-200 text-md md:text-[1.25vw]">
          We will update you once your designs are ready and you can access them
          from your dashboard.
        </p>
      </div>

      <div className="mb-10 flex flex-col">
        <h2 className="text-xl md:text-[1.6vw] md:leading-[2vw] font-bold mb-2">
          Do you offer free trial designs?
        </h2>
        <p className="text-gray-200 text-md md:text-[1.25vw] md:leading-[2vw]">
          Yes, we offer a free trial case. Please write to us at
          info@toothsketch.com. Our team will get in touch with you for further
          discussions on the same.
        </p>
      </div>

      <div className="mb-10 flex flex-col">
        <h2 className="text-xl md:text-[1.6vw] md:leading-[2vw] font-bold mb-2">
          Does ToothSketch do milling as well?
        </h2>
        <p className="text-gray-200 text-md md:text-[1.25vw] md:leading-[2vw]">
          No, ToothSketch is purely a design service. We can provide you with
          data your manufacturer of choice requires to mill and manufacture the
          restoration.
        </p>
        <p className="mt-4 text-gray-200 text-md md:text-[1.25vw]">
          Our mission is to empower our partner labs by assisting the with the
          design element of their digital workflow. ToothSketch does not intent
          to compete with its partner labs and hence has consciously decided not
          to undertake milling jobs.
        </p>
        <p className="mt-4 text-gray-200 text-md md:text-[1.25vw]">
          For dental practices looking for a manufacturer – we will be happy to
          provide references of a local dental lab in your neighbourhood.
        </p>
      </div>

      <div className="mb-10 flex flex-col">
        <h2 className="text-xl md:text-[1.6vw] md:leading-[2vw] font-bold mb-2">
          Can the designs be manufactured by any manufacturer?
        </h2>
        <p className="text-gray-200 text-md md:text-[1.25vw] md:leading-[2vw]">
          Yes, we are an open platform. Our designs can be sent to any
          manufacturer. You may share our contact details along with the
          ToothSketch case ID in case they have any follow-up queries.
        </p>
      </div>

      <div className="mb-10 flex flex-col">
        <h2 className="text-xl md:text-[1.6vw] md:leading-[2vw] font-bold mb-2">
          How do payments work?
        </h2>
        <p className="text-gray-200 text-md md:text-[1.25vw] md:leading-[2vw]">
          We accept debit card/ credit card and wise transfer.
        </p>
        <p className="mt-4 text-gray-200 text-md md:text-[1.25vw]">
          An invoice will be generated after every design job. Along with the
          invoice, we will share a secure payment link, powered by Stripe, where
          you can pay directly using your debit or credit card by clicking on
          Pay now.
        </p>
        <p className="mt-4 text-gray-200 text-md md:text-[1.25vw]">
          For recurring business engagements, we can share our bank details for
          a wise transfer on a monthly basis.
        </p>
      </div>

      <div className="mb-10 flex flex-col">
        <h2 className="text-xl md:text-[1.6vw] md:leading-[2vw] font-bold mb-2">
          What files can I send you?
        </h2>
        <p className="text-gray-200 text-md md:text-[1.25vw] md:leading-[2vw]">
          We are compatible with all systems. We design using an open software,
          which accepts all STL, DME and DICOM files. In case of any
          peculiarities, please reach out to us at enquiry@toothsketch.com
        </p>
      </div>

      <div className="mb-10 flex flex-col">
        <h2 className="text-xl md:text-[1.6vw] md:leading-[2vw] font-bold mb-2">
          Can I track my case?
        </h2>
        <p className="text-gray-200 text-md md:text-[1.25vw] md:leading-[2vw]">
          Yes, once you login, the status of your case will be visible on your
          dashboard under my cases. Also, you will receive an email once your
          design is complete.
        </p>
        <p className="mt-4 text-gray-200 text-md md:text-[1.25vw]">
          Our portal allows live tracking. Once uploaded, you can track your
          case on the portal where you will also receive your files, once
          completed.
        </p>
      </div>

      <div className="mb-10 flex flex-col">
        <h2 className="text-xl md:text-[1.6vw] md:leading-[2vw] font-bold mb-2">
          What about adjustments in my design?
        </h2>
        <p className="text-gray-200 text-md md:text-[1.25vw] md:leading-[2vw]">
          We will be happy to make further adjustments to your satisfactions at
          no extra charge. Post delivery of the completed design files, you can
          always reach out to us if you have any feedback regarding your design
          or if you need any adjustments.
        </p>
        <p className="mt-4 text-gray-200 text-md md:text-[1.25vw]">
          You can communicate directly with the design team while they are
          working on your project.
        </p>
      </div>

      <div className="mb-10 flex flex-col">
        <h2 className="text-xl md:text-[1.6vw] md:leading-[2vw] font-bold mb-2">
          How long will ToothSketch store old cases?
        </h2>
        <p className="text-gray-200 text-md md:text-[1.25vw] md:leading-[2vw]">
          We store old cases for a period of 6 months from the date of request.
        </p>
      </div>
    </div>
    </>
  );
};

export default FAQ;
